import store from "@/store";
import makePermission from "@/permissions/makePermission";

export default makePermission((): {
    redirectRouteName: string;
    hasPermission: () => Promise<boolean>;
} => ({
    redirectRouteName: "home",
    async hasPermission() {
        await store.dispatch("auth/init");
        return !store.getters["auth/isAuthenticated"];
    }
}));
